import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, LogIn, ArrowLeft } from 'lucide-react';
import { API } from '../api';
import axios from 'axios';

const AdminLogin = () => {
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setErr('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem('travelsera_admin_token', res.data.token);
      nav('/admin/dashboard');
    } catch (e2) {
      setErr(e2?.response?.status === 401 ? 'Incorrect password. Please try again.' : 'Unable to sign in. Try again shortly.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0d64a8] to-[#0a2a4a] flex items-center justify-center p-5">
      <div className="absolute top-5 left-5">
        <Link to="/" className="flex items-center gap-1.5 text-white/90 hover:text-white text-sm">
          <ArrowLeft size={16} /> Back to site
        </Link>
      </div>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#0d64a8]/10 text-[#0d64a8] flex items-center justify-center mx-auto mb-3">
            <Lock size={22} />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Admin Sign In</h1>
          <p className="text-sm text-gray-500 mt-1">Travelsera team access only</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">Admin Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoFocus
              className="w-full border border-gray-200 rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#0d64a8]"
            />
          </div>
          {err && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-md px-3 py-2">{err}</div>
          )}
          <button
            disabled={loading}
            className="w-full bg-[#0d64a8] hover:bg-[#0a548e] disabled:opacity-70 text-white font-medium py-2.5 rounded-md flex items-center justify-center gap-2 transition"
          >
            <LogIn size={15} /> {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-[11px] text-gray-400 text-center mt-6">
          Access is limited to Travelsera team members. Unauthorized access attempts are logged.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
